import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/toast/toast.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-assigned-audit',
  templateUrl: './assigned-audit.component.html',
  styleUrls: ['./assigned-audit.component.scss'],

})
export class AssignedAuditComponent implements OnInit {
  page = new Page();
  id: any;
  filteredData: any;
  filterdata: any;
  rows: any[] = [];
  columns: any[] = [];
  loading = false;
  statusId: any;
  showdata: any;
  selectedViewRole: number = 1;

  remark = {
    sRemark: '',
    iSocietySocietyID: 0,
    iAllotAuditorID: 0,

  };
  transId: number | null = null;
  transIdToUse: any;
  iAllotAuditorID: any;
  paymentAmount: string = '';
  showError: boolean = false
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  base64String2: string = '';
  base64String: string = '';
  roleID: any;
  userId: any;
  data: any;
  payment = {
    sAmountReceiptAuditor: '',
    iSocietyDetailsID: 0,
    sAmountRemarkAuditor: '',
    sAmountReceiptFilenname: '',
    documentExtension: ''
  };
  acceptedRows: { [id: number]: boolean } = {};
  isocietydetailsid: any;
  actionName: any;
  auditService: any;
  cd: any;
  hrremark: any;
  arReject: any;
  arsendback: any;

  constructor(private router: Router, private authService: AuthService, private auditstatus: AuditStatusService, private route: ActivatedRoute, private toastService: ToastService, private audit: AuditService) {
    this.page.pageNumber = 0;
    this.page.pageSize = 10;
    this.roleID = this.authService.currentUserValue.roleId;
    this.userId = this.authService.currentUserValue.id;



    this.route.params.subscribe((params) => {
      if (params['id']) {

        this.statusId = parseInt(params['id']);

      }
    });
    this.setPage({ offset: 0 });
  }
  ngOnInit() {

    this.columns = [

      { prop: 'ssocietyname', name: 'Society Name' },
      { prop: 'ssocietytype', name: 'Society Type' },
      { prop: 'sblockinspectorname', name: 'Block Inspector' },
      { prop: 'sblockinspectormob', name: 'Contact' },
      { prop: 'ssecretaryname', name: 'Society Secretary' },
      { prop: 'role', name: 'Request Type' },
      //  { prop: 'sauditstatus', name: 'Audit Status' },
    ];


  }

  setPage(pageInfo: any) {

    this.page.pageNumber = pageInfo.offset;
    var postData = {
      pageSize: this.page.pageSize,
      pageNumber: this.page.pageNumber,
      totalRecords: 0,
      filter: {
        status: this.statusId,
        societyType: 0,
        block: 0,
        search: '',
      },
    };

    this.page.pageNumber = pageInfo.offset;
    this.loading = true;
    this.audit.Getassignedaudit(postData).subscribe({

      next: (response) => {
        this.loading = false;
        if (response.status === 200) {
          this.auditstatus.SetStatus(this.statusId);
          this.rows = response.data.map((row: any) => ({
            ...row,
            //  isDisabled: !!row.isForwarded,
            //  iscomplted: !!row.isCheckListCompleted,
            isCheckListCompleted: !!row.isCheckListCompleted,
            isForwarded: !!row.isForwarded,
            payment: !!row.isPaymentDone,
            AuditorPaymentReceived: !!row.auditorPaymentReceived,
            auditorPaymentConfirm: !!row.auditorPaymentConfirm,
            isDeptMemberAllot: !!row.isDeptMemberAllot,
            role: row.isLiquidatorRequest ? "Liquidator Audit" : "Auditor",
            auditorCancel: !!row.auditorRequestCancel

          }));
          //this.paymentAmount = response.data[0].auditPaymentAmount;
          this.transId = response?.data?.[0]?.iSocietyDetailsTranID ?? 0;
          this.data = this.rows;
          this.arReject = [...new Set(this.data.map((item: any) => item.auditorRequestCancelRemark))];
          this.hrremark = [...new Set(this.data.map((item: any) => item.redirectToHrRemark))];
          this.arsendback = [...new Set(this.data.map((item: any) => item.arSendBackRemark))];

          this.iAllotAuditorID = this.data.map((item: any) => item.iAllotAuditorID);

          this.transId = this.data.map((item: any) => item.iSocietyDetailsTranID);
          this.paymentAmount = this.data.map((item: any) => item.auditPaymentAmount);


          this.page.totalRecords = response.totalRecords;
        } else {
          this.rows = [];
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Error fetching auditors:', error);
      },
    });

  }
  getsocietydata(id: any) {

    this.audit.GetSocietyDetails(id).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.showdata = response.data;

        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Error fetching auditors:', error);
      },

    });
  }
  openRemarkModal(id: number, actionNames: string, iAllotAuditorId: number) {
    this.remark = { sRemark: '', iSocietySocietyID: id, iAllotAuditorID: iAllotAuditorId };
    this.isocietydetailsid = id;
    this.actionName = actionNames;

  }
  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name);
      if (
        this.fileExtension !== 'jpg' &&
        this.fileExtension !== 'jpeg' &&
        this.fileExtension !== 'png' &&
        this.fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        return;
      }
      this.selectedFile = event.target.files[0];
      this.convertToBase64(file, 1);
      this.cd.detectChanges();
    }
  }
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  openPaymentModal(id: number) {
    this.payment = { sAmountRemarkAuditor: '', sAmountReceiptAuditor: '', sAmountReceiptFilenname: '', documentExtension: '', iSocietyDetailsID: id };
    this.isocietydetailsid = id;
  }
  paymentRemark() {
    if (this.paymentValid()) {

      this.payment.iSocietyDetailsID = this.isocietydetailsid;
      this.payment.sAmountReceiptAuditor = this.base64String || '';
      this.payment.sAmountReceiptFilenname = this.fileName;
      this.payment.documentExtension = this.fileExtension;

      this.audit.paymentConfirm(this.payment).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          console.clear();
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    } else {
      this.showError = true; // Trigger error messages in UI
      this.toastService.showError('Please enter a valid remark and upload a receipt.');
    }
  }

  paymentValid(): boolean {
    if (!this.payment) return false;

    return (
      !!this.payment.sAmountRemarkAuditor &&
      !!this.payment.sAmountReceiptAuditor
    );
  }

  isRejecting = false;

  UpdateRemark() {
    if (this.remarksValid()) {
      this.isRejecting = true;

      this.remark.iSocietySocietyID = this.isocietydetailsid;
      //  this.remark.actionName = this.actionName;
      this.remark.sRemark = this.remark.sRemark?.trim() || '';

      this.remark.iAllotAuditorID = Array.isArray(this.iAllotAuditorID)
        ? this.iAllotAuditorID[0]
        : this.iAllotAuditorID;
      this.audit.updateRemark(this.remark).subscribe(
        (response) => {
          this.isRejecting = false;

          this.toastService.showSuccess(response.message);
          this.router.navigate([`/dashboard`])

          this.remark.sRemark = '';
        },
        (error) => {
          this.isRejecting = false;

          this.toastService.showError(error.message);

        }
      );
    } else {
      this.toastService.showError('Please enter a valid remark.');
    }
  }

  reset() {
    this.remark.sRemark = '';
  }

  remarksValid(): boolean {
    return this.remark && this.remark.sRemark.trim().length > 0;
  }
  navigateToChecklist(
    id: number,
    actionName: string,
    iSocietyDetailsTranID: number,
    iAllotAuditorID: number
  ) {

    if (this.statusId == 0) {

      Swal.fire({
        title: 'Warning',
        text: 'Are you sure you want to accept this Application?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {

        if (result.isConfirmed) {
          this.callChecklistApi(id, actionName, iSocietyDetailsTranID, iAllotAuditorID);
        }

      });

    } else {
      this.callChecklistApi(id, actionName, iSocietyDetailsTranID, iAllotAuditorID);
    }
  }
  callChecklistApi(
    id: number,
    actionName: string,
    iSocietyDetailsTranID: number,
    iAllotAuditorID: number
  ) {

    this.audit.GetTransId(id, actionName, iSocietyDetailsTranID, iAllotAuditorID)
      .subscribe({
        next: (response: any) => {

          if (response && response.data) {

            this.filteredData = response.data;
            this.statusId = this.auditstatus.getStatus();

            const newTransId = response.data;

            const transIdToUse =
              (iSocietyDetailsTranID == 0)
                ? newTransId
                : iSocietyDetailsTranID;

            this.router.navigate(
              [`/audit/final-checklist`, id, transIdToUse],
              {
                state: {
                  actionName: actionName,
                  iSocietyDetailsTranID: transIdToUse,
                  iAllotAuditorID: iAllotAuditorID
                }
              }
            );

          } else {
            console.error("No data received from API.");
          }
        },

        error: (error: any) => {
          console.error("Error fetching transaction details:", error);
        }
      });
  }




}
